import UndoIcon from '@mui/icons-material/Undo';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import CardText from 'components/Card/Text';
import CardTitle from 'components/Card/Title';

import PrimaryButton from './PrimaryButton';

const Error = ({ message, onLogin }) => (
  <>
    <CardTitle title='Error' />
    <CardText noTopPadding>
      There was an error signing in: {message}
    </CardText>
    <PrimaryButton
      icon={useMemo(
        () => <UndoIcon />,
        [],
      )}
      label='Start Over'
      onClick={onLogin}
    />
  </>
);

Error.propTypes = {
  message: PropTypes.string.isRequired,
  onLogin: PropTypes.func.isRequired,
};

export default Error;
